import React, { useState } from "react";
import { Modal, Button } from "antd";
import FeedbackForm from "../Feedback/FeedbackForm";

const AddFeedbackModal = ({ onFeedbackAdded }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);

  const handleSuccess = (newFeedback) => {
    if (onFeedbackAdded) onFeedbackAdded(newFeedback);
    setIsModalOpen(false);
  };

  return (
    <>
      <Button
        color={"cyan"}
        variant="outlined"
        onClick={showModal}
      >
        + Կարծիք
      </Button>

      <Modal
        title="Ավելացնել Կարծիք"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
        width={800}
        destroyOnHidden
      >
        <FeedbackForm
          onSuccess={handleSuccess}
          onClose={handleCancel}
        />
      </Modal>
    </>
  );
};

export default AddFeedbackModal;